import { useData } from '@app/data/repositories';
import { ViewerScreen } from './ViewerScreen';
import { useViewer } from './useViewer';

/** Вход просмотра документа: данные и навигация здесь, сам экран о них не знает. */
export function ViewerRoute({ documentId, onBack }: { documentId: string; onBack: () => void }) {
  const { db, files } = useData();
  const { state, actions } = useViewer(documentId, db, files);

  return <ViewerScreen state={state} actions={actions} onBack={onBack} />;
}
